import {
  deleteFolderFromTree,
  insertFilesToTree,
  insertFolderToTree,
  removeFileById,
  removeNodeById,
  replaceNodeById,
} from '@crema/utility/helper/Utils';
import {
  GET_LIST_PERMINDOK,
  ADD_KONSEP_TEMUAN,
  GET_LIST_KONSEP_TEMUAN,
  GET_DETAIL_PERMINDOK,
  EDIT_PERMINDOK,
  ADD_PERMINDOK,
  ADD_PERMINDOK_ATTACHMENT,
  ADD_FILE_KKP,
  GET_LIST_OPTION_BPK,
  DELETE_PERMINDOK_ATTACHMENT,
  GET_LIST_KONSEP_TEMUAN_KKP,
  GET_DETAIL_KONSEP_TEMUAN,
  DELETE_ALL_PERMINDOK_ATTACHMENT,
  ADD_KONSEP_TEMUAN_ATTACHMENT,
  DELETE_KONSEP_TEMUAN_ATTACHMENT,
  DELETE_ALL_KONSEP_TEMUAN_ATTACHMENT,
  GET_COUNTER_BPK,
  ADD_FOLDER_KKP,
  DELETE_FOLDER_BPK,
  DELETE_FOLDER_KKP,
  DELETE_PERMINDOK,
  DELETE_FILE_KKP,
  GET_OPTION_UNKER_PERMINDOK,
  PATCH_READ_FILE,
  GET_LIST_PERMINDOK_MONITORING,
  GET_LIST_KONSEP_TEMUAN_MONITORING,
  GET_DETAIL_PERMINDOK_MONITORING,
  GET_SUB_DETAIL_PERMINDOK,
} from 'shared/constants/ActionTypes';

const initialState = {
  permindok: {
    success: false,
    message: null,
    count: 0,
    next: null,
    previous: null,
    result: [],
  },
  optionunkerpermindok: [],
  permindokAttachment: [],
  option_bpk: [],
  detail_permindok: {
    success: false,
    message: null,
    result: [],
  },
  konsepTemuan: {
    list: null,
    detail: null,
    attachments: [],
  },
  counter: null,
};

const bpkdriveReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUNTER_BPK:
      return {
        ...state,
        counter: action.payload,
      };

    case GET_LIST_PERMINDOK:
      return {
        ...state,
        permindok: {
          ...action.payload,
          result: action.payload?.result ?? [],
        },
      };

    case GET_LIST_PERMINDOK_MONITORING:
      return {
        ...state,
        permindok: {
          ...action.payload,
          result: action.payload?.result ?? [],
        },
      };

    case PATCH_READ_FILE: {
      const fileId = action.payload;

      const updateReadStatus = (node) => {
        let updatedNode = {...node};

        // update files_detail jika ada
        if (node.files_detail) {
          updatedNode.files_detail = node.files_detail.map((file) =>
            file.id === fileId ? {...file, is_read: true} : file,
          );
        }

        // rekursi ke children jika ada
        if (node.children) {
          updatedNode.children = node.children.map((child) =>
            updateReadStatus(child),
          );
        }

        return updatedNode;
      };

      return {
        ...state,
        detail_permindok: {
          ...state.detail_permindok,
          result: updateReadStatus(state.detail_permindok.result),
        },
      };
    }

    case GET_DETAIL_PERMINDOK:
      return {
        ...state,
        detail_permindok: {
          ...action.payload,
          result: action.payload?.result ?? [],
        },
      };

    case GET_SUB_DETAIL_PERMINDOK: {
      const {id} = action.meta;

      return {
        ...state,
        detail_permindok: {
          ...state.detail_permindok,
          result: {
            ...state.detail_permindok.result,
            children: replaceNodeById(
              state.detail_permindok.result.children,
              id,
              action.payload.result,
            ),
          },
        },
      };
    }

    case GET_DETAIL_PERMINDOK_MONITORING:
      return {
        ...state,
        detail_permindok: {
          ...action.payload,
          result: action.payload?.result ?? [],
        },
      };

    case ADD_PERMINDOK:
      return {
        ...state,
        permindok: {
          ...state.permindok,
          result: [...state.permindok.result, ...action.payload],
        },
      };

    case GET_OPTION_UNKER_PERMINDOK:
      return {
        ...state,
        optionunkerpermindok: action.payload,
      };

    case ADD_FOLDER_KKP: {
      const newFolders = action.payload || [];
      const parentId = action.meta?.parent_id;

      return {
        ...state,
        detail_permindok: parentId
          ? {
              ...state.detail_permindok,
              result: insertFolderToTree(
                state.detail_permindok.result,
                parentId,
                newFolders,
              ),
            }
          : state.detail_permindok,
      };
    }

    case DELETE_FOLDER_KKP: {
      const deletedId =
        action.meta?.deletedId ??
        (typeof action.payload === 'object'
          ? action.payload?.id
          : action.payload);

      return {
        ...state,
        detail_permindok: {
          ...state.detail_permindok,
          result: removeNodeById(state.detail_permindok.result, deletedId),
        },
      };
    }

    case DELETE_PERMINDOK: {
      const deletedId =
        action.meta?.deletedId ??
        (typeof action.payload === 'object'
          ? action.payload?.id
          : action.payload);

      const newList = state.permindok.result.filter(
        (item) => item.id !== deletedId,
      );

      return {
        ...state,
        permindok: {
          ...state.permindok,
          result: newList,
          count: newList.length,
        },
      };
    }

    case DELETE_FILE_KKP: {
      const deletedFileId =
        typeof action.payload === 'object' ? action.payload.id : action.payload;

      return {
        ...state,
        detail_permindok: {
          ...state.detail_permindok,
          result: removeFileById(state.detail_permindok.result, deletedFileId),
        },
      };
    }

    case ADD_PERMINDOK_ATTACHMENT:
      return {
        ...state,
        permindokAttachment: [...state.permindokAttachment, action.payload],
      };

    case ADD_FILE_KKP: {
      const newFiles = action.payload || [];
      const folderId = action.meta?.folder_id;

      return {
        ...state,
        detail_permindok: {
          ...state.detail_permindok,
          result: insertFilesToTree(
            state.detail_permindok.result,
            folderId,
            newFiles,
          ),
        },
      };
    }

    case EDIT_PERMINDOK: {
      const updatedItem = action.payload;

      return {
        ...state,
        permindok: {
          ...state.permindok,
          result: state.permindok.result.map((item) =>
            item.id === updatedItem.id ? updatedItem : item,
          ),
        },

        detail_permindok: updatedItem,
      };
    }

    case DELETE_PERMINDOK_ATTACHMENT: {
      const deletedFileId = action.payload;

      return {
        ...state,
        detail_permindok: {
          ...state.detail_permindok,
          result: {
            ...state.detail_permindok.result,
            files_detail: state.detail_permindok.result.files_detail.filter(
              (file) => file.id !== deletedFileId,
            ),
          },
        },
      };
    }

    case DELETE_ALL_PERMINDOK_ATTACHMENT:
      return {
        ...state,
        permindokAttachment: [],
      };

    case GET_LIST_KONSEP_TEMUAN:
      return {
        ...state,
        konsepTemuan: {
          ...state.konsepTemuan,
          list: action.payload,
        },
      };

    case GET_LIST_KONSEP_TEMUAN_MONITORING:
      return {
        ...state,
        konsepTemuan: {
          ...state.konsepTemuan,
          list: action.payload,
        },
      };

    case GET_DETAIL_KONSEP_TEMUAN:
      return {
        ...state,
        konsepTemuan: {
          ...state.konsepTemuan,
          detail: action.payload,
        },
      };

    case GET_LIST_KONSEP_TEMUAN_KKP:
      return {
        ...state,
        konsepTemuan: {
          ...state.konsepTemuan,
          list: action.payload,
        },
      };

    case GET_LIST_OPTION_BPK:
      return {
        ...state,
        option_bpk: action.payload,
      };

    case ADD_KONSEP_TEMUAN_ATTACHMENT:
      return {
        ...state,
        konsepTemuan: {
          ...state.konsepTemuan,
          attachments: [...state.konsepTemuan.attachments, action.payload],
        },
      };

    case DELETE_KONSEP_TEMUAN_ATTACHMENT:
      return {
        ...state,
        konsepTemuan: {
          ...state.konsepTemuan,
          attachments: action.payload,
        },
      };

    case DELETE_ALL_KONSEP_TEMUAN_ATTACHMENT:
      return {
        ...state,
        konsepTemuan: {
          ...state.konsepTemuan,
          attachments: [],
        },
      };

    default:
      return state;
  }
};

export default bpkdriveReducer;
